import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import './nuevoStroDark.css'
export default function FrenteDark() {
    const id = useParams().id;
    const [denuncia, setDenuncia] = useState([]);
    const [cargando, setCargando] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const resDenuncia = await axios.get(
                    `https://back.agsseguros.online/api/frente/${id}`
                );
                setDenuncia(resDenuncia.data);
                setCargando(true);
            } catch (error) {
                console.error("Error fetching data", error);
            }
        };
        fetchData();
    }, [id]);
    function formatDate(inputDate) {
        const date = new Date(inputDate);
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
    }
    const ivaNros = [
        { id: 1, NOMBRE: "CONSUMIDOR FINAL" },
        { id: 2, NOMBRE: "LIBERADO" },
        { id: 3, NOMBRE: "NO RESP/EXENTO" },
        { id: 4, NOMBRE: "RESP NO INSCRIPTO" },
        { id: 5, NOMBRE: "RESP INS NO AG. RET" },
        { id: 6, NOMBRE: "RESP INSC GR/CONTR" },
        { id: 7, NOMBRE: "RESP INS AG. RET" },
        { id: 8, NOMBRE: "NO CATEG" },
        { id: 9, NOMBRE: "MONOTRIBUTO" },
    ];
    function getNombreById(id) {
        const result = ivaNros.find((item) => item.id === id);
        return result ? result.NOMBRE : null;
    }
    const iva = getNombreById(denuncia?.qnx?.ados_tip_iva);
    const jurisdiccionPas = ["", "Persona Fisica", "Persona Juridica"];
    const ingresosBrutosPas = [
        "",
        "No Inscripto",
        "Juridiccional",
        "Convenio Multilateral",
    ];
    const tipoJubilacionPas = [
        "",
        "No Inscripto",
        "Industria y Comercio",
        "Autonomo",
    ];
    const serSocialPas = [
        "",
        "No Afiliado",
        "Personas Fisicas",
        "Personas Juridicas",
    ];
    const ivaPas = [
        "",
        "CONSUMIDOR FINAL",
        "LIBERADO",
        "NO RESP/EXENTO",
        "RESP NO INSCRIPTO",
        "RESP INS NO AG. RET",
        "RESP INSC GR/CONTR",
        "RESP INS AG. RET",
        "NO CATEG",
        "MONOTRIBUTO",
    ];
    return (
        <>
            {cargando ? (
                <>
                    <section>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex">
                                <h6 className="titulo text-white">NRO STRO:</h6>
                                <h6 className="titulo ms-2 text-white">
                                    {denuncia?.nroStro?.toString().substring(3)}
                                </h6>
                            </div>
                            <div className="d-flex">
                                <h6 className="titulo text-white">FECHA CARGA:</h6>
                                <h6 className="titulo ms-2 text-white">
                                    {formatDate(denuncia?.fechaCarga)}
                                </h6>
                            </div>
                            <div className="d-flex">
                                <h6 className="titulo text-white">FECHA STRO:</h6>
                                <h6 className="titulo ms-2 text-white">
                                    {formatDate(denuncia?.fechaStro)}
                                </h6>
                            </div>
                            <div className="d-flex">
                                <h6 className="titulo text-white">SELLO:</h6>
                                <h6 className="titulo ms-2 text-white">
                                    {formatDate(denuncia?.fechaDenuncia)}
                                </h6>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex ">
                                <h6 className="titulo2 text-white">POLIZA:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">{denuncia?.qnx?.ados_poliza}</h6>
                            </div>
                            <div></div>
                            <div className="d-flex">
                                <h6 className="titulo2 text-white">END:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">{denuncia?.qnx?.ados_endoso}</h6>
                            </div>
                            <div></div>
                            <div className="d-flex">
                                <h6 className="titulo2 text-white">PROP:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">{denuncia?.qnx?.ados_nro_cc}</h6>
                            </div>
                            <div></div>
                            <div className="d-flex">
                                <h6 className="titulo2 text-white">STROS:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">
                                    {denuncia?.otrasDenuncias.porPatente.length > 1 ||
                                        denuncia?.otrasDenuncias.porPoliza.length > 1
                                        ? "SI"
                                        : "NO"}
                                </h6>
                            </div>
                            <div></div>
                        </div>
                        <div className="bordeWhiteDark mb-3"></div>
                        <div className="row">
                            <div className="col-8 d-flex align-items-center">
                                <h6 className="titulo2 text-white">PRODUCTOR:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">{`${denuncia?.productor?.pro_productor} - ${denuncia?.productor?.pro_raz_social}`}</h6>
                            </div>
                            <div className="col-4 d-flex align-items-center">
                                <h6 className="titulo2 text-white">DOM.PAS:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">
                                    {denuncia.productor?.pro_domicilio}
                                </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-8 d-flex align-items-center">
                                <h6 className="titulo2 text-white">LOCALIDAD:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">
                                    {denuncia.productor?.pro_localidad}
                                </h6>
                            </div>
                            <div className="col-4 d-flex align-items-center">
                                <h6 className="titulo2 text-white">CP:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">
                                    {denuncia.productor?.pro_nro_cuit}
                                </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">CATEGORIA IVA:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">
                                    {ivaPas[Number(denuncia?.productor?.pro_cat_iva)]}
                                </h6>
                            </div>
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">CUIT:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">
                                    {denuncia?.productor?.pro_nro_cuit}
                                </h6>
                            </div>
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">NRO JUB:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">
                                    {denuncia?.productor?.pro_nro_jub}
                                </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">TIPO JUBILACION:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">
                                    {
                                        tipoJubilacionPas[
                                        Number(denuncia?.productor?.pro_jubilacion)
                                        ]
                                    }
                                </h6>
                            </div>
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">ING BRUTOS:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">
                                    {
                                        ingresosBrutosPas[
                                        Number(denuncia?.productor?.pro_ing_brutos)
                                        ]
                                    }
                                </h6>
                            </div>
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">NRO IB:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">
                                    {denuncia?.productor?.pro_nro_ingbto}
                                </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">JURISDICCION PAS:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">
                                    {jurisdiccionPas[Number(denuncia?.productor?.pro_cod_jur)]}
                                </h6>
                            </div>
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">SER. SOCIAL:</h6>
                                <h6 className="subTitulo2 ms-2 text-white">
                                    {serSocialPas[Number(denuncia?.productor?.pro_ser_social)]}
                                </h6>
                            </div>
                        </div>
                        <div className="bordeWhiteDark mb-3"></div>
                        <div className="row">
                            <div className="col-9 d-flex align-items-center">
                                <h6 className="titulo2 text-white">ASEGURADO:</h6>
                                <h6 className="subTitulo2 text-white ms-2">
                                    {denuncia?.qnx?.ados_nom_aseg}
                                </h6>
                            </div>
                            <div className="col-3 d-flex align-items-center">
                                <h6 className="titulo2 text-white">CUIT:</h6>
                                <h6 className="subTitulo2 text-white ms-2">
                                    {denuncia?.qnx?.ados_cuit}
                                </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-9 d-flex align-items-center">
                                <h6 className="titulo2 text-white">DOMICILIO:</h6>
                                <h6 className="subTitulo2 text-white ms-2">
                                    {denuncia?.qnx?.ados_dir_aseg}
                                </h6>
                            </div>
                            <div className="col-3 d-flex align-items-center">
                                <h6 className="titulo2 text-white">CP:</h6>
                                <h6 className="subTitulo2 text-white ms-2">
                                    {denuncia?.qnx?.ados_cdp_aseg}
                                </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">LOCALIDAD:</h6>
                                <h6 className="subTitulo2 text-white ms-2">
                                    {denuncia?.qnx?.ados_loc_aseg}
                                </h6>
                            </div>
                        </div>
                        <div className="bordeWhiteDark mb-3"></div>
                        <div className="row">
                            <div className="col-6 d-flex align-items-center">
                                <h6 className="titulo2 text-white">PATENTE:</h6>
                                <h6 className="subTitulo2 text-white ms-2">{denuncia?.qnx?.ados_patente}</h6>
                            </div>
                            <div className="col-6 d-flex align-items-center">
                                <h6 className="titulo2 text-white">AÑO:</h6>
                                <h6 className="subTitulo2 text-white ms-2">{denuncia?.qnx?.ados_modelo}</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">ITEM:</h6>
                                <h6 className="subTitulo2 text-white ms-2">
                                    {denuncia?.item ? denuncia?.item[0]?.item_desc : null}
                                </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">VEHICULO:</h6>
                                <h6 className="subTitulo2 text-white ms-2">
                                    {denuncia?.qnx?.ados_vehiculo}
                                </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 d-flex align-items-center">
                                <h6 className="titulo2 text-white">USO:</h6>
                                <h6 className="subTitulo2 text-white ms-2">
                                    {denuncia?.uso ? denuncia.uso[0]?.uso_desc : null}
                                </h6>
                            </div>
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">MOTOR:</h6>
                                <h6 className="subTitulo2 text-white ms-2">{denuncia?.qnx?.ados_motor}</h6>
                            </div>
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">CHASIS:</h6>
                                <h6 className="subTitulo2 text-white ms-2">{denuncia?.qnx?.ados_chasis}</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">SUMA ASEG:</h6>
                                <h6 className="subTitulo2 text-white ms-2">
                                    {denuncia?.qnx?.ados_sum_aseg}
                                </h6>
                            </div>
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">TIPO STRO:</h6>
                                <h6 className="subTitulo2 text-white ms-2">{denuncia?.catStro}</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6 d-flex align-items-center">
                                <h6 className="titulo2 text-white">COD RIESGO:</h6>
                                <h6 className="text-white">{"-----"}</h6>
                            </div>
                            <div className="col-6 d-flex align-items-center">
                                <h6 className="titulo2 text-white">VALOR GNC:</h6>
                                <h6 className="subTitulo2 text-white ms-2">{`${denuncia?.qnx?.ados_eq_gas}`}</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6 d-flex align-items-center">
                                <h6 className="titulo2 text-white">SICOBE:</h6>
                            </div>
                            <div className="col-6 d-flex align-items-center">
                                <h6 className="titulo2 text-white">IVA:</h6>
                                <h6 className="subTitulo2 text-white ms-2">{`${denuncia?.qnx?.ados_tip_iva} - ${iva}`}</h6>
                            </div>
                        </div>
                        <div className="bordeWhiteDark mb-3"></div>
                        <div className="row">
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">POLIZA:</h6>
                                <h6 className="subTitulo2 text-white ms-2">{denuncia?.qnx?.ados_poliza}</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 d-flex align-items-center">
                                <h6 className="titulo2 text-white">INI.VIG:</h6>
                                <h6 className="subTitulo2 text-white ms-2">
                                    {formatDate(denuncia?.qnx?.ados_fech_ini)}
                                </h6>
                            </div>
                            <div className="col-4 d-flex align-items-center">
                                <h6 className="titulo2 text-white">FECHA EMISION:</h6>
                                <h6 className="subTitulo2 text-white ms-2">
                                    {formatDate(denuncia?.qnx?.ados_fech_emi)}
                                </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 d-flex align-items-center">
                                <h6 className="titulo2 text-white">FIN.VIG:</h6>
                                <h6 className="subTitulo2 text-white ms-2">
                                    {formatDate(denuncia?.qnx?.ados_fech_fin)}
                                </h6>
                            </div>
                            <div className="col-4 d-flex align-items-center">
                                <h6 className="titulo2 text-white">FECHA EMI.PROP:</h6>
                                <h6 className="subTitulo2 text-white ms-2">
                                    {formatDate(denuncia?.qnx?.ados_fech_prod)}
                                </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">COBERTURA:</h6>
                                <h6 className="subTitulo2 text-white ms-2">{denuncia?.qnx?.ados_cobert}</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col d-flex align-items-center">
                                <h6 className="titulo2 text-white">PLAN:</h6>
                                <h6 className="subTitulo2 text-white ms-2">
                                    {denuncia?.qnx?.ados_plan > 70
                                        ? `${denuncia?.qnx?.ados_plan} - Debito automatico`
                                        : denuncia?.qnx?.ados_plan}
                                </h6>
                            </div>
                        </div>
                        <div className="bordeWhiteDark mb-3"></div>
                        <h5 className="titulo text-white"> {denuncia.endosos.length > 1 ? "Endosos" : "No existen Endosos"}</h5>
                        {denuncia.endosos.length > 1 ? (
                            <table class="">
                                <thead>
                                    <tr>
                                        <th scope="col">
                                            <h6 className="titulo4 text-white">Pza / Prop</h6>
                                        </th>
                                        <th scope="col">
                                            <h6 className="titulo4 text-white">Fec. Ini</h6>
                                        </th>
                                        <th scope="col">
                                            <h6 className="titulo4 text-white">Fec. Fin</h6>
                                        </th>
                                        <th scope="col">
                                            <h6 className="titulo4 text-white">Causa</h6>
                                        </th>
                                        <th scope="col">
                                            <h6 className="titulo4 text-white">Usuario</h6>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {denuncia.endosos.map((d) => {
                                        return (
                                            <tr>
                                                <td className="subTitulo4 text-white">{d.ados_poliza}</td>
                                                <td className="subTitulo4 text-white">
                                                    {formatDate(d.ados_fech_ini)}
                                                </td>
                                                <td className="tsubTitulo4 text-white">
                                                    {formatDate(d.ados_fech_fin)}
                                                </td>
                                                <td className="tsubTitulo4 text-white">{d.ados_cod_end}</td>
                                                <td className="tsubTitulo4 text-white">{d.ados_w_user}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        ) : null}
                        <div className="bordeWhiteDark mb-3"></div>
                        <h5 className="titulo text-white"> {denuncia.otrasDenuncias.porPatente.length > 1 || denuncia.otrasDenuncias.porPoliza.length > 1 ? "Stros" : "No existen Otras Denuncias"}</h5>
                        {denuncia.otrasDenuncias.porPatente.length > 1 || denuncia.otrasDenuncias.porPoliza.length > 1 ? (
                            <table class="">
                                <thead>
                                    <tr>
                                        <th scope="col">
                                            <h6 className="titulo4 text-white">Nro Stro</h6>
                                        </th>
                                        <th scope="col">
                                            <h6 className="titulo4 text-white">Asegurado</h6>
                                        </th>
                                        <th scope="col">
                                            <h6 className="titulo4 text-white">Patente</h6>
                                        </th>
                                        <th scope="col">
                                            <h6 className="titulo4 text-white">Pol/Pres</h6>
                                        </th>
                                        <th scope="col">
                                            <h6 className="titulo4 text-white">Fecha Stro</h6>
                                        </th>
                                        <th scope="col">
                                            <h6 className="titulo4 text-white">Inic. Vigencia</h6>
                                        </th>
                                        <th scope="col">
                                            <h6 className="titulo4 text-white">Fin Vigencia</h6>
                                        </th>
                                        <th scope="col">
                                            <h6 className="titulo4 text-white">Tipo Stro</h6>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {denuncia.otrasDenuncias.porPatente.filter((d) => d.id !== denuncia.id).map((d) => {
                                        return (
                                            <tr>
                                                <td className="subTitulo4 text-white">
                                                    {d?.nroStro?.toString().substring(3)}
                                                </td>
                                                <td className="subTitulo4 text-white">{d.nombreConductorAseg}</td>
                                                <td className="subTitulo4 text-white">{d.dom}</td>
                                                <td className="subTitulo4 text-white">{d.pza}</td>
                                                <td className="subTitulo4 text-white">
                                                    {formatDate(d.fechaStro)}
                                                </td>
                                                <td className="subTitulo4 text-white">
                                                    {d?.qnx !== null ? formatDate(d.qnx?.ados_fech_ini) : '---'}
                                                </td>
                                                <td className="subTitulo4 text-white">
                                                    {d.qnx !== null ? formatDate(d.qnx?.ados_fech_fin) : '---'}
                                                </td>
                                                <td className="subTitulo4 text-white">{d.catStro}</td>
                                            </tr>
                                        );
                                    })}
                                    {denuncia.otrasDenuncias.porPoliza.filter((d) => d.id !== denuncia.id).map((d) => {
                                        return (
                                            <tr>
                                                <td className="subTitulo4 text-white">
                                                    {d?.nroStro?.toString().substring(3)}
                                                </td>
                                                <td className="subTitulo4 text-white">{d.nombreConductorAseg}</td>
                                                <td className="subTitulo4 text-white">{d.dom}</td>
                                                <td className="subTitulo4 text-white">{d.pza}</td>
                                                <td className="subTitulo4 text-white">
                                                    {formatDate(d.fechaStro)}
                                                </td>
                                                <td className="subTitulo4 text-white">
                                                    {d?.qnx !== null ? formatDate(d.qnx?.ados_fech_ini) : '---'}
                                                </td>
                                                <td className="subTitulo4 text-white">
                                                    {d.qnx !== null ? formatDate(d.qnx?.ados_fech_fin) : '---'}
                                                </td>
                                                <td className="subTitulo4 text-white">{d.catStro}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        ) : null}
                    </section>
                </>
            ) : (
                <div className="center">
                    <div class="spinner-border text-success center" role="status">
                        <span class="visually-hidden center">Loading...</span>
                    </div>
                </div>
            )}
        </>
    );
}
